export var CreditsActionTypes;
(function (CreditsActionTypes) {
    CreditsActionTypes["FETCH_CREDITS_ATTEMPT"] = "FETCH_CREDITS_ATTEMPT";
    CreditsActionTypes["FETCH_CREDITS_SUCCESS"] = "FETCH_CREDITS_SUCCESS";
    CreditsActionTypes["FETCH_CREDITS_FAILURE"] = "FETCH_CREDITS_FAILURE";
})(CreditsActionTypes || (CreditsActionTypes = {}));
